var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-rideo-btn",class:{'is-checked': _vm.isChecked, 'disabled': _vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }